<template>
  <div class="service">
    <div class="icon-bar">
      <img height="80px" :src="news.img ? news.img : imgUrl" alt="img" />
    </div>

    <div class="service-content">
      <p class="service-detail">
        {{ lang == "EN" ? news.title : news.enTitle }}
      </p>
    </div>
    <div style="color: #909399; position: absolute; right: 40px">
      {{ news.createTime.split(" ")[0] }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    news: Object,
    lang: String,
  },
  data() {
    return {
      imgUrl: require("../assets/news1.svg"),
    };
  },
  mounted() {
    console.log("-----------");
  },
};
</script>

<style>
.icon-bar {
  min-width: 120px;
  display: flex;
  justify-content: center;
}

.service-title {
  font-size: 18px;
  font-weight: bold;
}

.service-detail {
  width: 100%;
  color: #000;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-bottom: 10px;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.service {
  display: flex;
  position: relative;
  /* margin-bottom: 10px;
  padding-bottom: 10px; */
  height: 120px;
  line-height: 120px;
  border-bottom: 1px solid #f2f6fc;
  align-items: center;
  cursor: pointer;
}

.service-content {
  width: 65%;
  margin-left: 40px;
}

.service-content h1 {
  line-height: 20px;
  margin: 0;
  font-weight: normal;
  font-size: 1.5em;
  text-align: left;
  margin-top: 10px;
}

.service-content p {
  line-height: normal;
  text-align: left;
  font-size: 18px;
}
</style>
